import { HTMLChakraProps, chakra } from "@chakra-ui/react";
import { HTMLMotionProps, motion } from "framer-motion";
import Merge from "../IMerge";

type MotionDivProps = Merge<HTMLChakraProps<"div">, HTMLMotionProps<"div">>;
const MotionBox: React.FC<MotionDivProps> = motion(chakra.div);

export default MotionBox;
